import { render, staticRenderFns } from "./AppDivider.vue?vue&type=template&id=6628b87b"
import script from "./AppDivider.vue?vue&type=script&lang=js"
export * from "./AppDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports